import { render, staticRenderFns } from "./addEditAdmin.vue?vue&type=template&id=5e7a15c4"
import script from "./addEditAdmin.vue?vue&type=script&lang=js"
export * from "./addEditAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports